import { render, staticRenderFns } from "./ColorTab.vue?vue&type=template&id=bf9967f8&scoped=true&"
import script from "./ColorTab.vue?vue&type=script&lang=js&"
export * from "./ColorTab.vue?vue&type=script&lang=js&"
import style0 from "./ColorTab.vue?vue&type=style&index=0&id=bf9967f8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9967f8",
  null
  
)

export default component.exports